const getAgeFromDate = dateString => {
  const today = new Date();
  const birthDate = new Date(dateString);

  return today.getFullYear() - birthDate.getFullYear();
};

export default getAgeFromDate;
